<template>
  <div class="pagination__options-quick-jumper">{{ gotoText }}<input v-model="page$" class="input" type="text" @keyup.enter="$_changeValue">{{ pText }}</div>
</template>
<script>
import { isPInt } from '../../utils/assist'
import Locale from '../../mixins/locale'

export default {
  name: 'TPageElevator',
  mixins: [Locale],
  props: {
    current: {
      type: Number,
      validator: value => isPInt(value) && value > 0,
      default: 1
    }
  },
  data() {
    return {
      page$: 1
    }
  },
  computed: {
    gotoText() {
      return this.t('t.page.goto')
    },
    pText() {
      return this.t('t.page.p')
    }
  },
  methods: {
    // 设置私有方法
    $_changeValue() {
      if (isPInt(this.page$)) {
        this.$emit('on-change', parseInt(this.page$))
      } else {
        this.page$ = this.current
      }
    },
    gotoFirst() {
      this.page$ = 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// elevator.vue?37da4042